import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ValidationFn } from '../useValidation';

export function validateWorkTimeEntryDates(
  workTimeEntry: WorkTimeEntryToCreate
): ValidationFn {
  return (t) => {
    if (workTimeEntry.endDate < workTimeEntry.startDate) {
      return t(
        'hooks.validation.functions.validateWorkTimeEntryDates.endBeforeStartDate'
      );
    }
    return undefined;
  };
}
